import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/navigation-instruments/wind/wind.js';
      import {WindHistogramData} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/wind/wind.js';
import {VesselImage} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/watch.js';

      export interface Props {
     currentWindFromDirection?: number;
     currentWindSpeedBeaufort?: number;
     windHistogramData?: WindHistogramData[];
     vesselImage?: VesselImage;
     vesselHeadingDeg?: number
   }

      
  
      export type {WindHistogramData} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/wind/wind.js';
export type {VesselImage} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/watch.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcWind',
  props: {
    currentWindFromDirection: {},
    currentWindSpeedBeaufort: {},
    windHistogramData: {},
    vesselImage: {},
    vesselHeadingDeg: {}
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-wind',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})